import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
export var sessionQueryParameters = {
  tab: 'sessionTab',
  id: 'sessionId',
  startDate: 'sessionsStartDate',
  page: 'sessionsPage'
};
export var sessionQueryParameterValues = Object.values(sessionQueryParameters);
// Use 'sessionTab' instead of 'tab' to avoid potential colliding with the outer modal's (asset editor) tab param.
export function getSessionIsActiveTab(_ref) {
  var _searchParams$get;
  var location = _ref.location,
    tabName = _ref.tabName;
  var searchParams = new URLSearchParams(location.search);
  var tab = (_searchParams$get = searchParams.get(sessionQueryParameters.tab)) !== null && _searchParams$get !== void 0 ? _searchParams$get : 'details';
  return tab === tabName;
}
export function getSessionTabLink(_ref2) {
  var _location$search, _location$pathname;
  var tabName = _ref2.tabName,
    location = _ref2.location;
  var searchParams = new URLSearchParams((_location$search = location === null || location === void 0 ? void 0 : location.search) !== null && _location$search !== void 0 ? _location$search : '');
  searchParams.set(sessionQueryParameters.tab, tabName);
  return "".concat((_location$pathname = location === null || location === void 0 ? void 0 : location.pathname) !== null && _location$pathname !== void 0 ? _location$pathname : '', "?").concat(searchParams.toString());
}